import classNames from 'classnames';
import React from 'react';
import EfImg from '../ef-img';
import EfLink from '../ef-link';
import './index.scss';

export interface EfCardIntroBProps {
    /**
     * 主题色
     */
    theme?: 'white' | 'black';
    /**
     * 所有分辨率展示的资源链接
     */
    pc: string;
    /**
     * 分辨率小于等于1024px展示的资源链接
     */
    h5?: string;
    /**
     * 标题
     */
    title?: string;
    /**
     * 描述列表
     */
    descList?: string[];
    /**
     * 更多详情-链接
     */
    moreLink?: string;
    /**
     * 更多详情-文案
     */
    moreText?: React.ReactNode;
    /**
     * 购买-链接
     */
    buyLink?: string;
    /**
     * 购买-文案
     */
    buyText?: React.ReactNode;
    /**
     * 样式名
     */
    className?: string;
    /**
     * gtm more
     */
    gtm_more?: any;
    /**
     * gtm buy
     */
    gtm_buy?: any;
    /**
     * gtm position
     */
    gtm_position?: string;
}

/**
 * 维护:Fund
 *
 * 通用卡片 - 左右布局
 */
const EfCardIntroB: React.FC<EfCardIntroBProps> = ({
    theme = 'white',
    pc,
    h5,
    title,
    descList = [],
    moreLink,
    moreText,
    buyLink,
    buyText,
    className,
    gtm_more,
    gtm_buy,
    gtm_position,
    ...reset
}) => {
    const prefixCls = `ef-card-intro-b`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-${theme}`]: theme,
    });

    const gtm_more2 = gtm_more || {
        event: 'uaEvent',
        event_name: 'buy',
        product_name: title,
        position: gtm_position || 'Product Sale',
    };
    const gtm_buy2 = gtm_buy || {
        event: 'uaEvent',
        event_name: 'checkout',
        button_name: `${buyText}_${title}`,
    };

    return (
        <div className={classes} {...reset}>
            <div className={`${prefixCls}-img`}>
                <EfImg pc={pc} h5={h5} />
            </div>
            <div className="text-content">
                {title && <div className={`${prefixCls}-title`}>{title}</div>}
                <ul className={`${prefixCls}-desc-list`}>
                    {descList.map((item: string, index: number) => (
                        <li className={`${prefixCls}-desc-item`} key={index}>
                            {item}
                        </li>
                    ))}
                </ul>
                <div className={`${prefixCls}-footer`}>
                    {moreLink && moreText && (
                        <EfLink href={moreLink} dataLayer={gtm_more2} className={`${prefixCls}-btn ${prefixCls}-btn-more`}>
                            {moreText}
                        </EfLink>
                    )}
                    {buyLink && buyText && (
                        <EfLink href={buyLink} dataLayer={gtm_buy2} className={`${prefixCls}-btn ${prefixCls}-btn-buy`}>
                            {buyText}
                        </EfLink>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EfCardIntroB;
